export default {"src":"/_next/static/media/logo_fairprice_finest.e3144471.svg","height":40,"width":220,"blurWidth":0,"blurHeight":0};